import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ImagePlaceholder from '../../../assets/images/image_blank.png';
import Text from '../../../components/Text/Text';

const itemImageClassName = 'w-[60px] h-[60px] rounded-[5px] border border-[#EFF2F5] mr-[15px]';

const ArticlesRelatedListingItem = ({ item }) => {
  const [img, setImg] = useState(item?.listing_image_source?.split('|')[0]
    || item?.listing_image?.split('|')[0]
    || ImagePlaceholder);

  return (
    <div className="flex flex-row items-center" data-row={item.listing_id}>
      <img
        src={`${img}?w=62&h=62`}
        alt={item?.listing_title}
        className={itemImageClassName}
        onError={() => setImg(ImagePlaceholder)}
      />
      <div>
        <Text text={item?.listing_title} bold length={40} />
        <Text text={item?.listing_short_description} muted length={50} />
      </div>
    </div>
  );
};

ArticlesRelatedListingItem.propTypes = {
  item: PropTypes.shape({
    listing_image_source: PropTypes.string,
    listing_title: PropTypes.string,
    listing_short_description: PropTypes.string,
    listing_image: PropTypes.string,
    listing_id: PropTypes.string,
  }).isRequired
};

ArticlesRelatedListingItem.defaultProps = {};

export default ArticlesRelatedListingItem;
